import Collection from '../collection';
import Organization from '../model/organization';

export default Collection.extend( {
	endpoint: 'departments/all',
	responseAt: 'departments',
    model: Organization
} );


// WEBPACK FOOTER //
// ./src/js/collection/organizations.js